import type { ImportResult } from '../../../api/timeOff';

export const TIME_OFF_CSV_IMPORT_MAX_VISIBLE_ERRORS = 200;

interface TimeOffCsvImportResultsProps {
  result: ImportResult;
}

export function TimeOffCsvImportResults({ result }: TimeOffCsvImportResultsProps) {
  const visible = result.errors.slice(0, TIME_OFF_CSV_IMPORT_MAX_VISIBLE_ERRORS);
  const hidden = result.errors.length - visible.length;
  const attention = result.errors.length;

  return (
    <div className="time-off-csv-import-results">
      <strong>
        {attention === 0
          ? `Imported ${result.inserted}.`
          : `Imported ${result.inserted}. ${attention} row${attention === 1 ? '' : 's'} need attention.`}
      </strong>
      {visible.length > 0 ? (
        <>
          <table className="time-off-csv-import-results__table">
            <thead>
              <tr>
                <th>Row</th>
                <th>Employee</th>
                <th>Field</th>
                <th>Why</th>
              </tr>
            </thead>
            <tbody>
              {visible.map((err, idx) => (
                <tr key={`${err.rowNumber}-${err.field}-${idx}`}>
                  <td>{err.rowNumber > 0 ? err.rowNumber : '—'}</td>
                  <td>{err.employeeUpn || '—'}</td>
                  <td>{err.field}</td>
                  <td>{err.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {hidden > 0 ? (
            <p className="time-off-csv-import-results__more">and {hidden} more</p>
          ) : null}
        </>
      ) : null}
    </div>
  );
}
